import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Label, Radio, RadioGroup } from '@fluentui/react-components';
import { commonShimProps } from './utils';

const ChoiceGroupShimInternal = React.forwardRef((props, _ref) => {
  const {
    className,
    label,
    required,
    selectedKey,
    onChange,
    options,
    disabled,
    defaultSelectedKey,
  } = props;

  const [selectedValue, setSetSelectedValue] = useState(defaultSelectedKey);

  const DefaultRadio = (innerProps) => {
    const { option } = innerProps;
    const {
      key, text, onRenderField, onRenderLabel,
    } = option;

    const shouldRenderCustomField = onRenderField !== undefined;

    const shouldRenderCustomLabel = onRenderLabel !== undefined;

    const defaultRender = () => (
      <Radio
        key={key}
        value={key}
        disabled={option.disabled || false}
        label={shouldRenderCustomLabel ? {
          children: (Component, labelInnerProps) => {
            const defaultLabelRender = () => (<Component {...labelInnerProps} />);

            return onRenderLabel(labelInnerProps, defaultLabelRender);
          },
        } : text}
      />
    );

    return (
      <>
        {shouldRenderCustomField ? onRenderField(innerProps, defaultRender) : defaultRender()}
      </>
    );
  };

  const onChangeWrapper = (e, v9Result) => {
    // v9 just returns the value.
    // v8 expects the option object corresponding to the key.
    const { value } = v9Result;

    setSetSelectedValue(value);
    const optionItem = options.find(option => option.key === value);

    return onChange(e, optionItem);
  };

  const commonV9Props = commonShimProps(props);

  return (
    <>
      <Label required={required} disabled={disabled}>
        {label}
      </Label>
      <RadioGroup ref={_ref} value={selectedValue} selectedKey={selectedKey} className={className} onChange={onChangeWrapper} {...commonV9Props} defaultValue={defaultSelectedKey}>
        {options.map(option => (
          <DefaultRadio option={option} checked={option.key === selectedValue} />
        ))}
      </RadioGroup>
    </>
  );
});

ChoiceGroupShimInternal.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  selectedKey: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
    disabled: PropTypes.bool,
  })),
  disabled: PropTypes.bool,
  defaultSelectedKey: PropTypes.string,
};

ChoiceGroupShimInternal.defaultProps = {
  className: undefined,
  label: undefined,
  required: false,
  selectedKey: undefined,
  onChange: undefined,
  options: [],
  disabled: false,
  defaultSelectedKey: undefined,
};

export const ChoiceGroupShim = ChoiceGroupShimInternal;
